// Local card artwork shipped with the site (homepage showcase/hero). One
// folder per language under src/assets/img/cards/<lang>/, same file names.
// ponytail: folder list hardcoded — add a code here when a new folder lands.
export const CARD_IMAGE_LANGS = ['it', 'en'];

export function cardImage(id, lang) {
  const folder = CARD_IMAGE_LANGS.includes(lang) ? lang : 'it';
  return require(`../assets/img/cards/${folder}/${id}.jpg`);
}
